import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export interface Industry {
    id: number;
    name: string;
}

export const fetchOrganizationMemberList = async (params: any) => {
    const response = await axiosInterceptor.get(`${API.ORGANIZATION.MEMBERS}`, {
        params,
    });

    return response;
};

export const editMember = async (payload: any, id: any) => {
    const response = await axiosInterceptor.put(`${API.ORGANIZATION.UPDATE_MEMBER}/${id}`, payload);

    return response;
};

export const inviteMember = async (payload: any) => {
    const response = await axiosInterceptor.post(`${API.ORGANIZATION.INVITE_MEMBERS}`, payload);

    return response;
};

export const organizationStore = async (payload: any) => {
    const response = await axiosInterceptor.put(`${API.ORGANIZATION.STORE}`, payload);

    return response;
};

export const deleteMember = async (id: any) => {
    const response = await axiosInterceptor.delete(`${API.ORGANIZATION.DELETE_MEMBER}/${id}`);

    return response;
};

export const getIndustries = async (): Promise<Industry[]> => {
    const response = await axiosInterceptor.get(`${API.CUSTOMER.GET_INDUSTRIES}`);

    return response.data;
};
